<script>
import Layout from "../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { propertyService } from "../../../../services/managements/propertyservice/property.service";
import { projectService } from "../../../../services/projectservice/project.service";
import {invoiceService} from "../../../../services/managements/invoices/invoice.service";
import { servicehelpers } from "../../../../services/servicehelpers";
import List from "../../../../components/list";
import Screen from "../../../../components/screen";
import Fastview from "@/components/property-fastview";
import i18n from "../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Properties List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    List, 
    Fastview,
  },
  data() {
    return {
      ...Screen.Alert,
      ...Screen.Locate,
      propertyData: {},
      typeData: {},
      groupData: {},
      floorData: {},
      projectData: {},
      statusData: {},
      fetchingStats: false,
      title: "Properties List",
      invoiceData: {},

      viewTitle: '',
      viewObject: null,

    };
  },
  mounted() {
  
    // this.loadingpropertyTypeData();
    this.loadingData();

  },

  

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;
      propertyService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          let data = response.data;
          
          // custom field 
          data.forEach((item,index)=>{
            let bill_textg_color = (item.monthly_billing_date==this.currentDay())?'text-danger':'';
            var bill_text = `<span class="${bill_textg_color}">រៀងរាលថ្ងៃទី ${item.monthly_billing_date}</span> `;
            data[index]['monthly_billing'] =  bill_text
            let room_status = `<span style="background-color: ${item.room_status_color}" class="btn btn-sm py-0 px-2 text-black">${item.room_status_name}</sapn>`;
            data[index]['room_status_name'] =  room_status;

            // let date_approve_arrived = (item.==this.currentDay())?'text-danger':'';
          });

          response.data = data;
          this.propertyData = response;
         
          

          this.loadingprojectData();
          this.loadingRoomStatusData();
        });

        console.log(this.invoiceData)
    },

    loadingInvoice: function(id, param='') {
      let uri = `&clause={"clause":[{
        "conjuction":"and",
        "mg_invoices.property_id":{"value":${id}},
        "mg_invoices.status_id":{"value":1, "operator": "!="}
        }]}`;
      param = param ? param + uri : `?page=1`+uri;
      invoiceService.getList(param)
        .then(response => {
          this.invoiceData = response.data;
        });
    },

    loadingpropertyTypeData: function() {
      servicehelpers.getPropertyTypeData().then(response => {
        this.typeData = response;
      });
    },

    loadingpropertyFloorData: function(projectId = 0) {
      servicehelpers.getFloorData(projectId).then(response => {
        this.floorData = response;
        // console.log(this.floorData);
      });
    },

    loadingpropertyGroupData: function(projectId = 0) {
      servicehelpers.getGroupData(projectId).then(response => {
        this.groupData = response;
      });
    },

    loadingRoomStatusData: function() {
      servicehelpers.getRoomStatusData().then(response => {
        this.statusData = response;
      });
    },

    loadingprojectData: function() {
      projectService.getList()
        .then(response => {
          this.projectData = response;

        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },


    projectChanged: function(event) {
      // console.log("change::out ", event);
      this.loadingpropertyFloorData(event);
      this.loadingpropertyGroupData(event);
      // this.floorData.data = [];
      // this.project = event;
      // this.loadingPropertyData(this.project);
    },

    moreClick: function(event, id) {
      if(event == 'unkeep') {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('property.unkeep-message'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {
            this.unKeepClick(id);
          }
        });
      }
    },

    clickFastView(event) {
      this.viewTitle = event.name;
      this.viewObject = event.object;
      this.$refs['fast-view'].show();

      // console.log(JSON.stringify(event.object));
    },

    currentDay: function(){
      return this.$moment().clone().format('DD');
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader 
      :add="{
        icon: 'bx bx-time bx-tada', 
        title: 'manage.setting-monthly-billing-date', 
        link: 'manage-settting-property-monthly-biling',
      }"
      :buttons="[{
        icon: 'bx bx-key', 
        title: 'manage.keyover.text', 
        link: 'manage-keyover'
      }]"
      :title="$t('menuitems.property.text')" />
    <Fastview 
      id="fast-view"
      ref="fast-view"
      :title="viewTitle"
      :item="viewObject"
      :filters="$options.filters"
    /> 
    <List v-bind:dataList="propertyData" 
          @more="moreClick"
          @view="clickFastView"
          v-bind:view="{link: 'manage-property-view'}"
          v-bind:more="{
            sub: [
            {name: 'manage.room-status.rent-request', icon:'fa fa-paper-plane', link: 'manage-property-rent', column: 'id', show: {column: 'room_status_id', value: 1}},
            {name: 'manage.room-status.rent', icon:'bx bx-key', link: 'manage-property-rent-approve', column: 'id', show: {column: 'room_status_id', value: 2}},
            {name: 'manage.room-status.terminate-request', icon:'fa fa-hand-pointer', link: 'manage-property-rent-request-terminate', column: 'id', show: {column: 'room_status_id', value: 3}},
            {name: 'manage.room-status.terminated', icon:'fa fa-stop-circle', link: 'manage-property-rent-approve-terminate', column: 'id', show: {column: 'room_status_id', value: 4}},
            {name: 'manage.bill-invoice', icon:'fa fa-list', link: 'manage-invoice-generate', column: 'id'},
            {name: 'manage.payment', icon:'bx bx-dollar-circle', link: 'manage-property-invoice', column: 'id'},
            {
              name: 'manage.wattert-and-electrict-record', 
              icon:'bx bx-list-ul', 
              link: 'manage-property-utility', 
              column: 'id', 
              // show: 
              // {
              //   operation: '=',
              //   column: 'monthly_billing_date', 
              //   value: 12,
              // }
            },

            {name: 'Open Credit', icon:'bx bx-card', link: 'manage-open-credit', column: 'id'},
            {name: 'manage.rent.contract', icon:'bx bx-file', link: 'manage-property-rent-contract', column: 'id',  show: {column: 'room_status_id', value: 3}},
            {name: 'manage.rent.contract', icon:'bx bx-file', link: 'manage-property-rent-contract', column: 'id',  show: {column: 'room_status_id', value: 4}},
           
            {name: 'manage.service.setting', icon:'bx bx-cog', link: 'manage-setting-property-service-id', column: 'id'},
            {name: 'manage.keyover.contract', icon:'fas fa-check', link: 'manage-keyover-contract', column: 'id'},
            ]
          }"
          v-bind:filter="{
            search: ['properties.code', 'properties.description'], 
            dropdown: [{
              title: 'property.project',
              field: 'properties.project_id',
              data: this.projectData.data,
              method: (event) => projectChanged(event),
              default: 1,
              width: 2
            }, {
              title: 'property.status',
              field: 'properties.room_status_id',
              data: this.statusData.data
            }, {
              title: 'property.group',
              field: 'properties.property_group_id',
              data: this.groupData.data
            }, {
              title: 'property.floor',
              field: 'properties.project_floor_id',
              show: 'number',
              data: this.floorData.data
            }]
          }"
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[
            {name: 'code', type: 'fast-view'}, 
            {name:'last_watter_record', type:'currency'}, 
            {name:'last_electrict_record', type:'currency'}, 
          ]"
          v-bind:fields="[ 
            `code: ${$t('property.code')}`, 
            `project: ${$t('property.project')}`, 
            `customer: ${'ម្ចាស់បន្ទប់'}`, 
            `tenant_name: ${'អ្នកជួល'}`, 
            `last_watter_record: ${$t('manage.last-watter-record')}`, 
            `last_electrict_record: ${$t('manage.last-electrict-record')}`, 
            `monthly_billing: ${$t('manage.monthly-billing-date')}`, 
            `room_status_name: ${$t('manage.room-status.text')}`
            ]"
        />
  </Layout>
</template>